/* global window  */
import {
  compose,
  drop,
  dropLast,
  either,
  head,
  last,
  isNil,
  isEmpty,
  pluck,
  prop,
  zipObj,
} from "ramda";

const fetchTrophyWinners = (position) => compose(head, position);

const fetchPrizeAmount = compose(prop("content"), last, prop("table_columns"));

const fetchPrizeText = compose(last, prop("headers"));

const fetchHeader = compose(dropLast(1), prop("headers"));

const fetchTrophyHeaders = compose(drop(1), fetchHeader);

const pluckYearArray = compose(dropLast(1), pluck("content"), prop("table_columns"));

const pluckYearValues = compose(
  zipObj(["previous", "current", "difference"]),
  pluckYearArray,
);

const isEmptyOrNil = either(isNil, isEmpty);

export {
  fetchHeader,
  fetchPrizeAmount,
  fetchPrizeText,
  fetchTrophyHeaders,
  fetchTrophyWinners,
  isEmptyOrNil,
  pluckYearArray,
  pluckYearValues,
};
